import React, { FC, useContext } from "react";
import { LocalizeText } from "components/localizer";
import { THeadCell } from "utils/types";
import TopBar from "components/tableComponents/topBar";
import Banner from "components/banner";
import VKButton from "components/vkButton";
import { ModalContext } from "contexts/modals";
import ProductsTable from "components/tableComponents/productsTable";
import CreateProduct from "components/drawers/createProduct";
import ProductInformation from "components/drawers/productInformation";
import { usePermission } from "utils/hooks/usePermission";
import { usePaginationStore } from "utils/usePaginationStore";
import SearchFilterField from "components/searchFilterField";
import CommunityFilterInput from "components/searchFilterComponents/communityFilter";

export const productsHeadCells = (): THeadCell[] => {
    return [
        {
            id: "product_key",
            sortId: "product_key",
            label: <LocalizeText tag="productKey" />,
        },
        {
            id: "name",
            sortId: "name",
            label: <LocalizeText tag="product" />,
        },
        {
            id: "service_section",
            sortId: "service_section",
            label: <LocalizeText tag="serviceSection" />,
        },
        {
            id: "arena",
            sortId: "community__title",
            label: <LocalizeText tag="community" />,
        },
        {
            id: "amount_excl_vat",
            sortId: "price__amount_excl_vat",
            label: <LocalizeText tag="priceExclVat" />,
        },
        { id: "vat_proportion", sortId: "price__vat_proportion", label: <LocalizeText tag="vat" /> },
    ];
};

const ProductsView: FC = () => {
    const pagination = usePaginationStore("products", undefined, {
        page_size: 20,
        default_page_size: 20,
    });
    const { openDrawer } = useContext(ModalContext);
    const { hasPermissions } = usePermission();

    return (
        <div className="contentWrapper">
            <Banner
                title="products"
                subTitle="bannerProducts"
                imageStyle={{ objectPosition: "60% 40%" }}
                image={`${process.env.PUBLIC_URL}/assets/images/arenaStaff/products.jpg`}
            />
            <TopBar
                searchField={
                    <SearchFilterField
                        pagination={pagination}
                        label={<LocalizeText tag="searchProducts" />}
                        filterFields={<CommunityFilterInput pagination={pagination} />}
                    />
                }
                singleItem={
                    hasPermissions(["add_product"]) ? (
                        <VKButton
                            tag="createNew"
                            variant="outlined"
                            size="small"
                            sx={{ marginLeft: "auto" }}
                            onClick={() => openDrawer(CreateProduct, { pagination }, "createProduct")}
                        />
                    ) : null
                }
            />
            <ProductsTable
                pagination={pagination}
                onClick={(product) => openDrawer(ProductInformation, { product, pagination }, "productInfo")}
            />
        </div>
    );
};

export default ProductsView;
